<mat-menu #moreOptions="matMenu">
  <button mat-menu-item (click)="changeIncidentStatus()" [admRequiresFeatureRole]="roles['incident.change-status']">
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Ændr status
  </button>
  @if (incident.status !== incidentStatusEnum.Closed) {
    <button mat-menu-item (click)="onEdit()" [admRequiresFeatureRole]="roles['incident.write']">
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
      Redigér fejl
    </button>
  }
</mat-menu>

<mat-card class="list__unit" [class.list__unit--active]="mep.expanded">
  <mat-card-content class="list__unit-card">
    <div class="col col--number">{{ incident.number | formatIncident }}</div>
    <div class="col col--status">
      @if (incident.status.toString() === incidentStatus[incidentStatus.Reported]) {
        <mat-chip class="primary">
          {{ incident.status | translateIncidentStatusEnum }}
        </mat-chip>
      }
      @if (incident.status.toString() === incidentStatus[incidentStatus.Active]) {
        <mat-chip class="warn">
          {{ incident.status | translateIncidentStatusEnum }}
        </mat-chip>
      }
      @if (incident.status.toString() === incidentStatus[incidentStatus.Closed]) {
        <mat-chip class="success">
          {{ incident.status | translateIncidentStatusEnum }}
        </mat-chip>
      }
    </div>
    <div class="col col--location">
      {{ address.fullAddress }}
    </div>
    <div class="col col--stationNumber">{{ incident.stationNumber }}</div>
    <div class="col col--category">{{ incident.category | translateIncidentCategoryEnum }}</div>
    <div class="col col--created">{{ incident.created | date: 'short' }}</div>
    <div class="col col--solved">
      @if (incident.solved && incident.status === incidentStatus.Closed) {
        {{ incident.solved | date: 'short' }}
      }
      @if (!incident.solved) {
        -
      }
    </div>
    <div class="col col--createdBy">{{ incident.createdBy }}</div>

    <div class="col col--options">
      <button class="btn-icon" type="button" [admRequiresFeatureRole]="roles['incident.write']" [matMenuTriggerFor]="moreOptions">
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>
    <div class="col col--toggle">
      <button (click)="mep.expanded = !mep.expanded" class="btn-icon" type="button">
        <mat-icon [class.hidden]="mep.expanded">expand_more</mat-icon>
        <mat-icon [class.hidden]="!mep.expanded">expand_less</mat-icon>
      </button>
    </div>
  </mat-card-content>
  <div class="list__info" [class.list__info--open]="mep.expanded">
    <mat-expansion-panel #mep="matExpansionPanel" (opened)="loadIncidentDetails(incident.id)">
      @if (loading) {
        <div class="align-center flex">
          <mat-spinner color="accent" diameter="40" strokeWidth="2"></mat-spinner>
        </div>
      }
      <ng-template matExpansionPanelContent>
        @if (incidentDetails$ | async; as incidentDetails) {
          <adm-incident-list-details [incidentDetails]="incidentDetails"></adm-incident-list-details>
        }
      </ng-template>
    </mat-expansion-panel>
  </div>
</mat-card>
